<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th><input type="checkbox" :checked="selectAll" @change="toggleAll"></th>
        <th>{{$t('promo_code')}}</th>
        <th>{{ $t('product') }}</th>
        <th>{{ $t('discount') }}</th>
        <th>{{$t('remaining')}}</th>
        <th>{{ $t('status') }} <img src="../../assets/images/status.svg"></th>
        <th>{{ $t('due_date') }} <img src="../../assets/images/status.svg"></th>
        <th>{{$t('actions')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="(item, index) in items" :key="item.uuid || item.id || index">
        <td class="td-style"><input type="checkbox" @change="(e) => toggleItem(e, item.uuid || item.id)" :checked="selectedItemIds.includes(item.uuid || item.id)"></td>

        <td class="td-style">
          <div class="promotion-code-cell">
            <span class="promotion-code">{{ item.code }}</span>
          </div>
        </td>

        <td class="td-style">
          <div class="name-row">
            <template v-if="item.product?.images && item.product.images.length > 0">
              <img class="product-image" :src="item.product.images[0]" />
            </template>
            <template v-else>
              <div class="no-image-placeholder">
                <img src="../../assets/images/ibility-Logo.svg" class="placeholder-icon" />
              </div>
            </template>
            <template v-if="item.product?.title">
              <span class="product-title">{{ truncateText(item.product.title, 30) }}</span>
            </template>
            <template v-else>
              <em class="no-data-text">{{$t('product_couldnt_find')}}</em>
            </template>
          </div>
        </td>

        <td class="td-style">
          <span class="discount-percentage">%{{ item.promotionPercentage }}</span>
        </td>

        <td class="td-style">
          <span class="usage-info">{{ item.usageCount || 0 }}/{{ item.count }}</span>
        </td>

        <td class="td-style">
          <span class="status-badge" :class="item.isActive ? 'active' : 'inactive'">
            <span class="status-dot"></span>
            <span v-if="item.isActive">{{ $t('active') }}</span>
            <span v-else>{{$t('passive')}}</span>
          </span>
        </td>

        <td class="td-style">
          <span class="date-info">
            <img src="../../assets/images/datepicker.svg">
            {{ formatDate(item.endDate) }}
          </span>
        </td>

        <td class="td-style">
          <div class="action-buttons">
            <button
              class="action-btn edit"
              @click="editItem(item)"
            >
              <img src="../../assets/images/editPen.svg">
            </button>
            <button
              class="action-btn delete"
              @click="deleteItem(item)"
            >
              <img src="../../assets/images/trashOutline.svg">
            </button>
          </div>
        </td>
      </tr>

      <tr v-else>
        <td colspan="8" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{ $t('loading') }}</span>
        </td>
      </tr>

      <tr v-if="!loading && (!items || items.length === 0)">
        <td colspan="8" class="table-empty">
          <div class="empty-state">
            <img src="../../assets/images/noData.png" class="empty-icon">
            <p class="empty-title">{{$t('you_didnt_create_any_promo_code_yet')}}</p>
            <p class="empty-desc">{{$t('create_your_first_promo_code')}}</p>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { VueSpinner } from 'vue3-spinners';

export default {
  name: 'PromotionCodesTable',
  components: {
    VueSpinner
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItemIds: [],
      selectAll: false
    };
  },
  methods: {
    toggleAll() {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        this.selectedItemIds = this.items.map(item => item.uuid || item.id);
      } else {
        this.selectedItemIds = [];
      }
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    toggleItem(event, id) {
      if (event.target.checked) {
        this.selectedItemIds.push(id);
      } else {
        this.selectedItemIds = this.selectedItemIds.filter(selectedId => selectedId !== id);
      }
      this.selectAll = this.selectedItemIds.length === this.items.length;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    editItem(item) {
      this.$emit('edit-item', item);
    },
    deleteItem(item) {
      this.$emit('delete-item', item);
    }
  }
};
</script>

<style scoped>
.table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.content-table {
  width: 100%;
  border-collapse: collapse;
}

.header-table {
  background: #f8f9fa;
}

.trhead th {
  padding: 12px 16px;
  text-align: left;
  font-size: 14px;
  color: #344054;
  border-bottom: 1px solid #eaecf0;
  font-family: 'euclid_medium', sans-serif;
  text-transform: none !important;
}

.trhead th img {
  margin-left: 4px;
  width: 12px;
  height: 12px;
}

.tbody-container .tr-class {
  border-bottom: 1px solid #eaecf0;
  transition: background-color 0.2s ease;
}

.tbody-container .tr-class:hover {
  background-color: #f9fafb;
}

.td-style {
  padding: 16px;
  vertical-align: middle;
  font-size: 14px;
  color: #344054;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.no-image-placeholder {
  width: 40px;
  height: 40px;
  background: #f2f4f7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-icon {
  width: 20px;
  height: 20px;
  opacity: 0.5;
}

.product-title {
  font-weight: 500;
  color: #101828;
}

.promotion-code-cell {
  display: flex;
  align-items: center;
}

.promotion-code {
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  color: #344054;
}

.discount-percentage {
  color: #344054;
  font-weight: 600;
}

.usage-info {
  color: #6b7280;
  font-size: 13px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-badge.active .status-dot {
  background: #10b981;
}

.status-badge.inactive .status-dot {
  background: #ef4444;
}

.date-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-size: 13px;
}

.date-info img {
  width: 14px;
  height: 14px;
  opacity: 0.6;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #f9fafb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.action-btn img {
  width: 16px;
  height: 16px;
}

.table-loading,
.table-empty {
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
}

.table-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.empty-icon {
  width: 64px;
  height: 64px;
  opacity: 0.5;
}

.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.empty-desc {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  max-width: 400px;
  text-align: center;
}

.no-data-text {
  color: #9ca3af;
  font-style: italic;
  font-size: 13px;
}
</style>
